import Elemento from './Elemento.js';

export default class Campo extends Elemento {
  constructor() {
    super();
    this.seleccion = new Object();
    this.visible = new Boolean();
    this.caracteristicas = new Array();
    this.getCaracteristica = function (param) {
      var element =
        param == undefined ? (element = this.caracteristicaSel) : param;

      var filter = this.caracteristicas.find(
        (caracteristicaEl) => caracteristicaEl.cod == element
      );

      return filter != undefined ? filter : this.caracteristicas[0];
    };
    this.condicion = true;
    this.resolveCondicion = function () {
      const seleccion = this.seleccion;
      return eval(this.condicion);
    };
  }
}
